import gql from 'graphql-tag';

export default gql`
query ProductAutocomplete($filters: AdminProductFilters, $count: Int!, $page: Int) {
    adminProducts(
      filters: $filters,
      first: $count,
      page: $page
    ) {
        data {
          ext_id
          id
          name
        }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/productAutocomplete.ts